import React from "react";

/*
    Left Icon
    props:
        - title: string, override the default title 'large-left-arrow'
        - color: string, override the default color '#00549A' (bell blue)
*/

const LargeLeftIcon = (props) => (
    <svg className={props.className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <title>{props.title || "large-left-arrow"}</title>
        <path d="M16 20L8.5 12L16 4" stroke={props.color || "#00549A"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export default LargeLeftIcon;
